import type { ShopperCustomersTypes } from 'commerce-sdk-isomorphic'
import { middlewareGateway } from '~/gateway/middleware.gateway'

export function useActivateCustomer() {
  const error = ref<null | Error>(null)

  const sendActivationToken = async (email: string) => {
    let queryString = ''
    const locale = useNuxtApp().$i18n.locale.value
    queryString = ['en-CA', 'fr'].includes(locale) ? `?locale=${localeConfig[locale].code}` : ''

    const response = await middlewareGateway(`/next-gen/sfcc/customer/send-activation-token${queryString}`, {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({ email }),
    }).catch((e) => new Error(e))

    if (response instanceof Error) {
      error.value = response
      return false
    }
    return true
  }

  const activateCustomer = async (body: ShopperCustomersTypes.ResetPasswordRequest) => {
    const response = await middlewareGateway('/next-gen/sfcc/customer/activate', {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(body),
    }).catch((e) => new Error(e))

    if (response instanceof Error) {
      error.value = response
      return false
    }
    return true
  }

  return {
    activateCustomer,
    sendActivationToken,
    error,
  }
}
